/** @jsx jsx */
// External libraries
import { css, jsx } from '@emotion/core';
import { bool, func, object } from 'prop-types';
import { safeTrim, TextButton } from '@checkout/react-components';
import styled from '@emotion/styled';

// Internal modules
import { getContent } from '@/lib';
import { TEXT_COLOR } from '@/styles';

const NationalityContainer = styled.div`
  order: ${props => (props.isFirstField ? -1 : 0)};
`;

NationalityContainer.propTypes = {
  isFirstField: bool,
};

const P = styled.p`
  color: ${TEXT_COLOR};
  font-size: 13px;
`;

const ChangeButton = props => (
  <TextButton
    disabled={props.isFormSubmitting}
    onClick={props.clickHandler}
    onFocus={props.preloadNationalitySelect}
    onMouseOver={props.preloadNationalitySelect}
    styleOverrides={css({ lineHeight: 1 })}
  >
    {getContent('base.change')}
  </TextButton>
);

ChangeButton.propTypes = {
  clickHandler: func.isRequired,
  isFormSubmitting: bool.isRequired,
  preloadNationalitySelect: func,
};

const NationalityText = props => (
  <P css="nationality-text">
    {safeTrim(
      getContent('billing.changeNationality', {
        changeButton: !props.options?.length ? '' : <ChangeButton {...props} />,
        nationality: 'Indian',
      }),
    )}
  </P>
);

NationalityText.propTypes = {
  clickHandler: func.isRequired,
  isSubmitting: bool.isRequired,
  options: object,
  preloadNationalitySelect: func,
};

export { NationalityContainer, NationalityText };
